import api from "./client";

export async function fetchMyAddresses() {
  try {
    const data = await api.get("/user/addresses");
    return data?.data || data || [];
  } catch (error) {
    console.error("Addresses fetch error:", error);
    return [];
  }
}

export async function createAddress(addressData) {
  try {
    const data = await api.post("/user/addresses", addressData);
    return data?.data || data;
  } catch (error) {
    console.error("Address creation error:", error);
    throw error;
  }
}

export async function updateAddress(addressId, addressData) {
  try {
    const data = await api.put(`/user/addresses/${addressId}`, addressData);
    return data?.data || data;
  } catch (error) {
    console.error("Address update error:", error);
    throw error;
  }
}

export async function deleteAddress(addressId) {
  try {
    await api.delete(`/user/addresses/${addressId}`);
    return true;
  } catch (error) {
    console.error("Address deletion error:", error);
    throw error;
  }
}

export async function setDefaultAddress(addressId) {
  try {
    const data = await api.put(`/user/addresses/${addressId}/default`, {});
    return data?.data || data;
  } catch (error) {
    console.error("Set default address error:", error);
    throw error;
  }
}
